import { IdEnvironment } from "../constants/IdEnvironment";
var UtilEnvironment = /** @class */ (function () {
    function UtilEnvironment() {
        var _this = this;
        this.isEnvironment = function (env) { return _this.current === env; };
        this.isTest = function () { return process.env.NODE_ENV === IdEnvironment.Test; };
        this.isDevelopment = function () { return _this.isEnvironment(IdEnvironment.Development); };
        this.isIntegration = function () { return _this.isEnvironment(IdEnvironment.Integration); };
        this.isStaging = function () { return _this.isEnvironment(IdEnvironment.Staging); };
        this.isProduction = function () { return _this.isEnvironment(IdEnvironment.Production); };
    }
    Object.defineProperty(UtilEnvironment.prototype, "current", {
        get: function () {
            return process.env.REACT_APP_ENV;
        },
        enumerable: true,
        configurable: true
    });
    return UtilEnvironment;
}());
export var utilEnvironment = new UtilEnvironment();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilEnvironment.ts
// module id = 109
// module chunks = 3